<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1326145" style="color: #82a339"><b>CHORIZO AND <br/> BLACK BEAN NACHOS</b></p>
<p class="ext" id="d7e1326945"><b><i>These are serious nachos for chile lovers. Be sure to use fully cooked chorizo links, not soft bulk-style chorizo.</i></b></p>
<p class="h4" id="d7e1327945" style="color: #496210"><b>Prep: 20 minutes        Bake: 5 minutes per batch</b></p>
<p class="ul" id="d7e1328445">36 unbroken large tortilla chips</p>
<p class="ul" id="d7e1328745">3 large ripe plum tomatoes, cut into</p>
<p class="ul" id="d7e1329045">¼-inch pieces</p>
<p class="ul" id="d7e1329945">⅓ cup chopped fresh cilantro</p>
<p class="ul" id="d7e1330945">¼ teaspoon salt</p>
<p class="ul" id="d7e1331845">1 tablespoon vegetable oil</p>
<p class="ul" id="d7e1332145">1 fully cooked chorizo sausage (3 ounces), finely <br/> chopped, or ¾ cup finely chopped pepperoni <br/> (3 ounces)</p>
<p class="ul" id="d7e1333945">1 medium onion, finely chopped</p>
<p class="ul" id="d7e1334345">1 garlic clove, finely chopped</p>
<p class="ul" id="d7e1334645">½ teaspoon ground cumin</p>
<p class="ul" id="d7e1335545">1 can (15 to 19 ounces) black beans, <br/> rinsed and drained</p>
<p class="ul" id="d7e1336245">4 ounces Monterey Jack cheese, shredded (1 cup)</p>
<p class="ul" id="d7e1336545">2 pickled jalapeño chiles, very thinly sliced</p>
<p class="pub" id="d7e1337045" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 400°F. Arrange as many tortilla chips as will fit in single layer on two ungreased large cookie sheets. In small bowl, combine tomatoes, cilantro, and salt.</p>
<p class="pub" id="d7e1338745"><span style="color: #c15b49"><b>2.</b></span> In 10-inch skillet, heat oil over medium heat. Add chorizo, onion, garlic, and cumin; cook, stirring, until onion is tender, about 5 minutes. Stir in beans and heat through.</p>
<p class="pub" id="d7e1340645"><span style="color: #c15b49"><b>3.</b></span> Place 1 tablespoon bean mixture on each tortilla chip. Sprinkle cheese over beans and top each nacho with 1 slice jalapeño. Bake until cheese begins to melt, about 5 minutes.</p>
<p class="pub" id="d7e1342345"><span style="color: #c15b49"><b>4.</b></span> Spoon about 1 teaspoon tomato mixture on each nacho. Transfer nachos to platter. Makes 36 nachos.</p>
<p class="ntx" id="d7e1343645">Each nacho: About 51 calories, 2g protein, 4g carbohydrate, 3g total fat (1g saturated), 5mg cholesterol, 112mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c35_r1.vue?7e4fc1a6